export default __webpack_public_path__ + "static/media/gallery-wip-emitter_11.7897e9cd.jpg";